import { render } from "./InputHeight.vue?vue&type=template&id=2cf84ccd"
import script from "./InputHeight.vue?vue&type=script&lang=js"
export * from "./InputHeight.vue?vue&type=script&lang=js"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__